import { HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit, OnDestroy, AfterViewInit, HostListener } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from 'app/i18n';
import { PublicService } from 'app/services/public.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  templateUrl: 'rfid-upload-proof-modal.component.html',
  styleUrls: ['rfid-upload-proof-modal.component.scss']
})
export class RFIDUploadProofModalComponent implements OnInit, OnDestroy {
  @ViewChild('dpoIframe') iframeElement: ElementRef;
  @Input('orderId')   orderId; 
  @Input('jobId')     jobId; 
  @Input('token')     token; 
  @Input('artworkId') artworkId; 
  @Input('artworkSide') artworkSide; 
  @Output() emitUploadStatus = new EventEmitter<any>();
  uploadSide        : string;
  uploadedFile      : any;
  uploadStatus      : string;
  iframeLoadFlag    : boolean = false;
  loading           : boolean = false;
  widgetUrl         : SafeResourceUrl;   
  constructor(
    private sanitizer: DomSanitizer,
    private translate : TranslateService,
    private modalService : BsModalService,
    public bsModalRef: BsModalRef,
    private publicService     : PublicService,
    private toasterService    : ToasterService,
  ){ 

  }

  ngOnInit(): void {
    console.log('orderId',this.orderId)
    console.log('jobId',this.jobId)
    console.log('artworkId',this.artworkId)
    this.iframeLoadFlag = false;
    this.loading = false;

    let dpoUrl = '';
    if(environment.stage === 'prod'){
      dpoUrl = `https://services.print.avery.com/dpp/public/v3/dpo/widget/artwork/edit/?consumer=Magento&deploymentId=US_en&artworkId=${this.artworkId}`;
    }else{
      dpoUrl = `https://dpotest.print.avery.com/dpp/public/v3/dpo/widget/artwork/edit/?consumer=Magento&deploymentId=US_en_trial&artworkId=${this.artworkId}`;
    }
    this.widgetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dpoUrl);
    //"https://dpotest.print.avery.com/dpp/public/v3/dpo/widget/artwork/edit/?consumer=Magento&deploymentId=US_en_trial&artworkId=c1dddde9d3b80f9274e87b596bd942ad" 
    
    // let iframe = document.getElementById('dpoIframe');
    // console.log("🚀 ~ iframe:", iframe)    
    // window.addEventListener('message', this.handleIframeMessage.bind(this));
    
    // this.uploadStatus = 'RFID_WAITING_UPLOAD';
  }

  
  // ngAfterViewInit() {
  //   const iframeElement = this.iframeElement.nativeElement;
  //   const iframe = document.getElementById('dpoIframe') as HTMLIFrameElement;


  //   postMessage Approach
  //   iframeElement.onload = () => {
  //     console.log('Iframe loaded');
  //     // Send initial message to iframe
  //     try {
  //       iframeElement.contentWindow.postMessage({
  //         type: 'init',
  //         source: 'rfid-upload-proof'
  //       }, this.AVERY_ORIGIN);
  //     } catch (error) {
  //       console.warn('Failed to send initial message to iframe:', error);
  //     }
  //   };

  //   MutationObserver Approa
  //   iframeElement.onload = () => {
  //     try {
  //       const iframeDoc = iframeElement.contentDocument || iframeElement.contentWindow.document;
  //       if (iframeDoc) {
  //         console.log('Iframe loaded, setting up MutationObserver.');
  //         const observer = new MutationObserver((mutations) => {
  //           console.log('Iframe content changed:', mutations);
  //         });
  //         observer.observe(iframeDoc.body, {
  //           childList: true,
  //           subtree: true,
  //           characterData: true,
  //         });
  //         console.log('MutationObserver attached.');
  //       }
  //     } catch (error) {
  //       console.error('Error accessing iframe content:', error);
  //     }
  //   }
  // }

  ngOnDestroy(): void {
    this.iframeLoadFlag = false;
    this.loading = false;
    // console.log('Removing message listener');
    // Remove the exact same function reference
    // window.removeEventListener('message', this.messageListener);
  }


  apply(): void {
    this.emitUploadStatus.emit(this.artworkSide);
    this.modalService.hide(1);
    console.log('Applying');
    // this.loading = true;
  }

  onIframeLoad(): void {
    const iframe = this.iframeElement.nativeElement;
  
    try {
      // Check if we can access the iframe's document
      // This will throw an error if the iframe hasn't fully loaded
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      
      // Only set flag if we haven't already and the document is complete
      if (!this.iframeLoadFlag && iframeDoc.readyState === 'complete') {
        console.log('Iframe fully loaded');
        // this.iframeLoadFlag = true;
      }
    } catch (e) {
      console.log('Iframe still loading...');
      this.iframeLoadFlag = true;
    }

  }

  // From drag and drop
  onDropSuccess(event, side) {
    console.log("🚀 ~ event:", event)
    console.log("🚀 ~ side:", side)

    event.preventDefault();
    // this.handleFileInput(event.dataTransfer.files);
    this.uploadedFile = event.dataTransfer.files;


    // if(side === 'FRONT'){
    //   this.uploadedFile.front = event.dataTransfer.files;
    // }else{
    //   this.uploadedFile.back = event.dataTransfer.files;
    // }
  }

  // From click and attachment
  onAttachment(event, side) {
    console.log("🚀 ~ event:", event)
    console.log("🚀 ~ side:", side)
    // this.handleFileInput(event.target.files); 
    this.uploadedFile = event.target.files[0];

    // if(side === 'FRONT'){
    //   this.uploadedFile.front = event.target.files[0];
    // }else{
    //   this.uploadedFile.back = event.target.files[0];
    // }
    console.log("🚀 ~ this.uploadedFile:", this.uploadedFile)
  }

  handleFileInput() : void {
    this.uploadStatus = 'loading';
    const file = this.uploadedFile;
    console.log("🚀 ~ file:", file)
    
    const fileTypes = ['pdf', 'png', 'jpg'];  //acceptable file types

    // if (file.length !== 1) {
    //   throw new Error('Cannot use multiple files');
    // }
    let extension = file.name.split('.').pop().toLowerCase(),  //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types

    if (isSuccess) { // Accepted file extension format
      console.log('File upload with correct format')
      // const uploadedFile = file[0];
      // console.log(uploadedFile);
      // const fileName = `${this.orderId}_${this.jobId}_${this.uploadSide}`
      const fileName = `${this.orderId}_${this.jobId}_sideA` //Temp since front&back is in implemented in imposer

      console.log("🚀 ~ fileName:", fileName)
      const res = {
        fileName: fileName,
        contentType: 'application/pdf'
      }

      this.publicService.getSignedUrl(res).subscribe({
        next: (res: any) => {
          console.log('data', res);
          const signedUrl = res;

          // Upload the file to S3
          this.publicService.uploadFileToS3(file, signedUrl).subscribe((event) => {
            console.log("🚀 ~ event:", event)
            if (event.type === HttpEventType.UploadProgress && event.total) {
              let uploadProgress = Math.round((100 * event.loaded) / event.total);
              // console.log("🚀 ~ uploadProgress:", uploadProgress)
            } else if (event.type === HttpEventType.Response) {
              console.log('Upload complete:', event);
              this.uploadStatus = 'RFID_UPLOAD_COMPLETE'

              //Create additional GET request to a lambda that will check if imposed OUT file is there
              
            }
          });
        },
        error: (err: any) => {
          console.error('err', err);
        },
      });

    } else { //Invalid file format

    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deleteFile(index: number) {
    this.uploadedFile.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/public/rfid-upload-proof/rfid-upload-proof-modal.component.ts